/* CTR FAQ (sections/ctr-faq.liquid)
   Animates <details> open/close height so content below (e.g. the footer) glides instead of
   jumping. With data-single-open, opening one question closes the others. */
if (!customElements.get('ctr-faq')) {
  const DURATION = 320;
  const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

  class CtrFaq extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.ctr-faq__item'));
      this.single = this.hasAttribute('data-single-open');
      this.items.forEach((item) => {
        // The JS handles exclusivity; drop the native `name` so it can't close items instantly.
        item.removeAttribute('name');
        item.querySelector('summary').addEventListener('click', (event) => {
          event.preventDefault();
          this.toggle(item, !item.open);
        });
      });
    }

    reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    toggle(item, open) {
      if (open && this.single) {
        this.items.forEach((other) => {
          if (other !== item && other.open) this.animate(other, false);
        });
      }
      this.animate(item, open);
    }

    animate(item, open) {
      const summary = item.querySelector('summary');
      if (item._ctrAnimation) item._ctrAnimation.cancel();

      if (this.reducedMotion()) {
        item.open = open;
        return;
      }

      const startHeight = item.offsetHeight;
      if (open) item.open = true;
      const endHeight = open ? item.scrollHeight : summary.offsetHeight + this.borderWidth(item);

      item.style.overflow = 'hidden';
      item.classList.toggle('is-closing', !open);
      const animation = item.animate(
        { height: [`${startHeight}px`, `${endHeight}px`] },
        { duration: DURATION, easing: EASING }
      );
      item._ctrAnimation = animation;
      animation.onfinish = () => {
        if (!open) item.open = false;
        this.cleanup(item);
      };
      animation.oncancel = () => this.cleanup(item);
    }

    borderWidth(item) {
      return parseFloat(getComputedStyle(item).borderTopWidth) || 0;
    }

    cleanup(item) {
      item._ctrAnimation = null;
      item.style.overflow = '';
      item.classList.remove('is-closing');
    }
  }

  customElements.define('ctr-faq', CtrFaq);
}
